import { useAuth } from "@/auth/hooks";
import { BoxedSpinner } from "@ui/components/ui/spinner";
import { Navigate, Outlet } from "react-router";

/**
 * ProtectedRoute
 * Renders a spinner while auth initializes, redirects unauthenticated users to sign-in,
 * redirects users whose tenant setup is incomplete to the onboarding wizard,
 * and renders child routes for authenticated users with a complete tenant.
 */
export function ProtectedRoute() {
    const { isInitialized, hasAuthenticatedSession, authenticatedUser } = useAuth();

    if (!isInitialized) {
        return <BoxedSpinner />;
    }

    if (!hasAuthenticatedSession) {
        return <Navigate to="/auth/sign-in" replace />;
    }

    // Spec 0013 AC-1: redirect to onboarding when tenant setup is not complete
    if (authenticatedUser?.tenant && authenticatedUser.tenant.setup_completed_at === null) {
        return <Navigate to="/onboarding/company-details" replace />;
    }

    return <Outlet />;
}
